import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import notCamera from "../../../assets/img/off-camera.png";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "../../../hooks/useTranslation";

const useStyle = makeStyles({
  root: {
    display: "flex",
    height: "100%",
  },
  flexgrow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
  },
});

const NotCamera = () => {
  const classes = useStyle();
  const { t, BundleKey } = useTranslation();
  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item>
          <Typography variant="h5" gutterBottom>
            {t(BundleKey.ERROR_CAMERA_NOTFOUND)}
          </Typography>
        </Grid>
        <Grid item className={classes.flexgrow}>
          <img src={notCamera} alt="not" />
        </Grid>
      </Grid>
    </>
  );
};

export default NotCamera;
